import React from "react";

export function ReadyForReview({ status, children }) {
  return (
    <div className="d-flex review ">
      <div className="review_icon">
        <i class="fa fa-clock-o"></i>
      </div>
      Ready For Review
    </div>
  );
}

export function Pending({ status, children }) {
  return (
    <div className="d-flex pending rounded-pill px-3 py-1 pending-bg ">
      Pending
    </div>
  );
}

export function Verified({ status, children }) {
  return (
    <div className="d-flex text-white rounded-pill px-3 py-1 approved-bg">
      Verified
    </div>
  );
}

export function Rejected({ status, children }) {
  return (
    <div className="d-flex reject  rounded-pill px-3 py-1 rejected-bg">
      Rejected
    </div>
  );
}

export function Accepted({ status, children }) {
  return (
    <div className="d-flex approved">
      <div className="accept_icon">
        <i className="fa fa-check"></i>
      </div>
      Accepted
    </div>
  );
}
